"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _framerMotion = require("framer-motion");

var _hooks = require("../../../hooks");

var _typography = require("../../typography");

var _incrementalCounter = require("./incremental-counter.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var IncrementalCounter = function IncrementalCounter(_ref) {
  var _ref$hideOnMobile = _ref.hideOnMobile,
      hideOnMobile = _ref$hideOnMobile === void 0 ? false : _ref$hideOnMobile,
      endVal = _ref.endVal,
      startVal = _ref.startVal,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 1 : _ref$speed;

  var _useState = (0, _react.useState)(startVal),
      _useState2 = _slicedToArray(_useState, 2),
      nums = _useState2[0],
      setNums = _useState2[1]; // Speed is given to us in seconds. Convert to milliseconds for interval.


  (0, _hooks.useInterval)(function () {
    if (!endVal || num < endVal) setNums(function (num) {
      return num + 1;
    });
  }, speed * 1000);
  return /*#__PURE__*/_react["default"].createElement(_incrementalCounter.Wrapper, {
    hideOnMobile: hideOnMobile
  }, nums.toLocaleString().split('').map(function (num, index) {
    if (num === ',') {
      return /*#__PURE__*/_react["default"].createElement(_incrementalCounter.Comma, {
        key: "comma-".concat(index)
      }, ",");
    } else {
      return /*#__PURE__*/_react["default"].createElement(_incrementalCounter.NumberCard, {
        key: "counter-".concat(index)
      }, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
        initial: false
      }, /*#__PURE__*/_react["default"].createElement(_typography.Title, {
        as: _framerMotion.motion.div,
        key: "counter-".concat(index, "-").concat(num),
        transition: {
          stiffness: 150
        },
        initial: {
          y: -100,
          position: 'absolute'
        },
        animate: {
          y: 0,
          position: 'relative'
        },
        exit: {
          y: 100,
          position: 'absolute'
        },
        style: {
          willChange: 'transform'
        } // fixes an animation wobble in Safari.

      }, num)));
    }
  }));
};

IncrementalCounter.propTypes = {
  hideOnMobile: _propTypes["default"].bool,
  endVal: _propTypes["default"].number,
  startVal: _propTypes["default"].number,
  speed: _propTypes["default"].number
};
var _default = IncrementalCounter;
exports["default"] = _default;